var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 441,
    height: 298,
    viewBox: "0 0 441 298",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_19854)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 446,
    height: 300,
    rx: 19.4105,
    fill: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M391.397 38.9506C423.381 36.251 459.026 43.009 482.92 61.4157C506.871 79.8658 498.88 115.48 518.847 137.13C538.681 158.635 579.619 160.675 596.12 184.155C613.116 208.337 625.663 242.051 610.058 266.911C593.162 293.827 539.375 286.145 517.108 310.024C494.864 333.877 517.619 379.326 488.646 397.109C461.775 413.602 424.392 388.967 391.397 387.182C360.568 385.515 327.332 399.045 299.889 386.9C272.409 374.74 265.295 344.165 246.559 323.087C228.25 302.49 194.972 289.06 190.196 263.499C185.376 237.707 216.819 216.794 221.883 191.037C227.338 163.288 203.052 131.348 220.829 107.682C238.138 84.6395 279.22 87.8311 308.169 76.166C336.847 64.6101 359.856 41.613 391.397 38.9506Z",
    fill: "#F7DC6F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M382.013 64.5211C408.452 61.9129 437.917 68.4419 457.668 86.2247C477.466 104.049 470.861 138.456 487.366 159.372C503.762 180.149 537.602 182.119 551.242 204.803C565.291 228.166 575.663 260.737 562.763 284.754C548.797 310.758 504.335 303.336 485.929 326.406C467.541 349.45 486.351 393.358 462.401 410.538C440.189 426.472 409.287 402.672 382.013 400.948C356.529 399.338 329.055 412.408 306.37 400.676C283.655 388.928 277.774 359.389 262.286 339.026C247.151 319.127 219.643 306.152 215.695 281.457C211.711 256.54 237.703 236.336 241.888 211.452C246.398 184.644 226.323 153.786 241.017 130.923C255.325 108.661 289.285 111.745 313.215 100.475C336.921 89.3107 355.94 67.0932 382.013 64.5211Z",
    fill: "#85C1E9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.146 100.174C416.913 97.9305 442.285 103.548 459.294 118.847C476.342 134.183 470.654 163.785 484.867 181.78C498.986 199.655 528.126 201.351 539.872 220.867C551.97 240.967 560.901 268.99 549.793 289.653C537.766 312.026 499.48 305.641 483.629 325.488C467.796 345.315 483.993 383.091 463.37 397.872C444.242 411.581 417.632 391.105 394.146 389.622C372.201 388.236 348.543 399.482 329.008 389.387C309.448 379.28 304.384 353.866 291.047 336.347C278.014 319.226 254.327 308.063 250.927 286.817C247.496 265.379 269.878 247.996 273.482 226.587C277.365 203.523 260.078 176.974 272.732 157.304C285.053 138.151 314.296 140.804 334.902 131.108C355.316 121.502 371.694 102.387 394.146 100.174Z",
    fill: "#2ECC71"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_19854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 446,
    height: 300,
    rx: 19.4105,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1);
export default __webpack_public_path__ + "static/media/card1.6c03ab6cbce4fe331499dee0a33bab72.svg";
export { ForwardRef as ReactComponent };